export const UNSUPPORTED_FORMAT = 'This file type isn\'t supported.';
export const FILE_TOO_LARGE = 'Files greater than 15MB can\'t be sent through chat.';



// WEBPACK FOOTER //
// ./chat-app/constants/upload-file-errors.js